import {
  getPublisherDestinationUrlsService,
  getPublisherConfigurationService
} from '~/modules/retailMedia/services/configuration/publisher'

import { types } from './constants'

/**
 * GET Publisher Configuration
 * Traz todas as configurações de um publisher necessários para rodar uma campanha
 *
 * @param {strin} id Publisher ID
 * @returns PublisherConfiguration
 */
export const getPublisherConfiguration = (id: string) => ({
  type: types.list,
  payload: getPublisherConfigurationService(id)
})

/**
 * GET Publisher Configuration Destination URLs
 * Traz as possíveis URLs de destino para um publisher
 *
 * @param {strin} id Publisher ID
 * @returns PublisherConfigurationDestinationUrls
 */
let destinationCatalogRequestSeq = 0

export const getPublisherDestinationUrls = (
  id: string,
  campaignId?: string,
  { onSuccess, onError }: { onSuccess?: () => void; onError?: () => void } = {}
) => ({
  type: types.listDestinationUrls,
  payload: getPublisherDestinationUrlsService(id, campaignId),
  // The promise middleware copies `values` onto PENDING, FULFILLED and
  // REJECTED. A later request wins; an older response must not write.
  values: { requestId: ++destinationCatalogRequestSeq },
  onSuccess,
  onError
})

export default {
  getPublisherConfiguration,
  getPublisherDestinationUrls
}
